import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * The per-branch page, addressed by the two things that identify an environment
 * for a human: the project and the branch name.
 *
 * Deliberately alone in its own file. The card builds links *to* the page and
 * the page reads its params *from* the same ref, so keeping the ref next to
 * either of them would close an import cycle — the card would pull the page's
 * module in just to know where to point.
 *
 * The two params are the ones a user can name. The ArgoCD Application name is
 * not among them on purpose: it is composed by the applicationset, and putting
 * it in the URL would make every bookmark break the day that template changes.
 * The page resolves the Application from these two values instead.
 */
export const branchRouteRef = createRouteRef({
  params: ['project', 'branch'],
});

/**
 * The path the page above is mounted on, and the pattern the sidebar matches
 * the current location against to know which project it is looking at.
 *
 * Exported so those two have one source: the page extension in `plugin.tsx`
 * passes it as its `path`, and `components/projectsNav/ProjectsNav.tsx` hands it to
 * `useMatch`. Written as a literal here because a route ref carries its params
 * but not the shape of the path they sit in.
 */
export const BRANCH_PAGE_PATH = '/projets/:project/:branch';
